/**
 * Created by Lorenzo on 27/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('Authority', Authority);

    Authority.$inject = ['$resource'];

    function Authority ($resource) {
        var service = $resource('api/authorities', {}, {});

        return service;
    }
})();
